import api from './api';

export const timeEntryService = {
  list: (ticketId) => api.get(`/tickets/${ticketId}/time-entries`),
  summary: (ticketId) => api.get(`/tickets/${ticketId}/time-entries/summary`),
  create: (ticketId, data) => api.post(`/tickets/${ticketId}/time-entries`, data),
  delete: (ticketId, entryId) => api.delete(`/tickets/${ticketId}/time-entries/${entryId}`),
};
